// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__159xo","left":"styles_left__2Qbud"};